<template>
  <div class="xin">
    <!-- 面包屑
      <el-breadcrumb separator-class="el-icon-arrow-right" style="width:80%">
        <el-breadcrumb-item v-for="(item, index) in $route.meta" :key="index">
          <router-link v-if="item.url" :to="item.url">{{
            item.name
          }}</router-link>
          <a v-else>
            {{ item.name }}
          </a>
        </el-breadcrumb-item>-->
    <div class="switch">
      <el-tabs type="border-card">
        <!-- 数据统计  -->
        <el-tab-pane label="统计报表" lazy="1">
          <div class="switch1">
            <!--  表格 -->
            <div class="table">
              <!--  柱状图 -->
              <ve-histogram
                :data="chartData"
                :loading="loading"
                :data-empty="dataEmpty"
                :settings="chartSettings"
              ></ve-histogram>
              <!--  饼图 -->
              <ve-pie :data="chartData"></ve-pie>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--  底部 -->
  </div>
</template>
<script>
export default {
  data() {
    this.chartSettings = {
      metrics: ["发送邮件总量", "接收邮件总量"],
      dimension: ["日期"],
    };
    return {
      chartData: {
        columns: ["日期", "发送邮件总量", "接收邮件总量"],
        rows: [
          {
            日期: "20-07-17",
            发送邮件总量: 1393,
            接收邮件总量: 1093,
            下单率: 0.32,
          },
          {
            日期: "20-07-18",
            发送邮件总量: 45,
            接收邮件总量: 10973,
            下单率: 0.32,
          },
          {
            日期: "20-07-19",
            发送邮件总量: 1393,
            接收邮件总量: 1093,
            下单率: 0.32,
          },
          {
            日期: "20-07-20",
            发送邮件总量: 45,
            接收邮件总量: 1093,
            下单率: 0.32,
          },
          {
            日期: "20-07-21",
            发送邮件总量: 1393,
            接收邮件总量: 1093,
            下单率: 0.32,
          },
          {
            日期: "20-07-22",
            发送邮件总量: 13793,
            接收邮件总量: 1093,
            下单率: 0.32,
          },
          {
            日期: "20-07-23",
            发送邮件总量: 78,
            接收邮件总量: 1093,
            下单率: 0.32,
          },
        ],
      },
      loading: false,
      dataEmpty: false,
    };
  },
  watch:{
    chartData:{
      handler: function(nVal, oVal){
        if(this.chartData){
          if(nVal){
            this.setOption(nVal)
          }else{
            this.setOption(oVal)
          }
        }else{
          this.chartData();
        }
      },
      deep: true
    }
  },
  methods: {},
   beforeRouteUpdate(to, from, next) {
  
    // this.getSanji();

    next();
  },
};
</script>
<style lang="less" scoped>
.xin {
  width: 98%;
  display: flex;
  flex-direction: column;
  background: #fff;
  margin: 1%;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 0px 10px rgba(68, 73, 78, 0.25);
}
.xin .top {
  padding-bottom: 10px;
  border-bottom: 1px dashed rgba(1, 46, 248, 0.226);
}
.top {
  display: flex;
}
.main {
  border: 1px solid #dcdfe6;
  background: #f1f1f1;
  padding: 6px 0;
  text-align: left;
  margin-top: 20px;
}
.main .span {
  color: #333;
  padding: 0 20px;
  font-size: 12px;
}
.main p {
  font-size: 12px;
  color: #333;
  padding: 10px 0 0 20px;
}
// input 框高度

/deep/ .el-table th > .cell {
  width: 110%;
}
// 下拉

.el-input {
  width: 20%;
  padding: 5px 10px;
}

//  表格
.table {
  margin-top: 20px;
}

// 日期

// 底部
</style>
